import React from 'react';
import { SocialSharePlatformProvider } from '../SocialSharePlatformContext';
import { SocialSharePlatformProviderProps } from '../types';
import useTwitterSocialShare from './useTwitterSocialShare';

const TwitterSocialShareProvider: React.FC<SocialSharePlatformProviderProps> = ({
  children,
}) => {
  const platformData = useTwitterSocialShare();

  return (
    <SocialSharePlatformProvider value={platformData}>
      {children}
    </SocialSharePlatformProvider>
  );
};

export default TwitterSocialShareProvider;
